module.exports = __webpack_public_path__ + "img/hohlsaum_reinorange_ral2004.56494fa4.jpg";